<template>
  <vs-popup :active.sync="isActive" id="discount" :class="{'mobile-popup': isMobile}">
    <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
      <vs-button
        color="transparent"
        class="payment-label bg-primary2 text-white w-full"
        icon-pack="feather"
        icon="icon-percent"
      >
        İndirim Seçenekleri
      </vs-button>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="info-row" v-if="activePersonel">
      <vs-col vs-type="flex" class="w-auto">
        <p class="text-primary bold mr-3">Personel Adı :</p>
        <p class="text-primary">
          {{ activePersonel.name }}
        </p>
      </vs-col>
      <vs-col vs-type="flex" class="w-auto ml-auto">
        <p class="text-primary">{{ currentDate }}</p>
      </vs-col>
      <vs-col vs-type="flex" class="w-auto ml-3">
        <p class="text-primary">{{ currentTime }}</p>
      </vs-col>
    </vs-row>
    <vs-row
      vs-type="flex"
      vs-w="12"
      class="px-2 py-3"
      vs-justify="center"
      :class="{'mobile-content': isMobile}"
      :style="isMobile ? 'zoom: 90%; max-height: calc(100vh - 60px); overflow: auto; padding-bottom: 50px;' : 'zoom: 90%; max-height: calc(100vh - 100px); overflow: auto;'"
    >
      <vs-col vs-type="flex" :vs-w="isMobile ? 12 : 6">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="block" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
              <vs-col vs-type="flex" vs-w="5" vs-justify="center">
                <div
                  class="w-full half-friendly-border bg-secondary sale-box-shadow discount-old-title"
                >
                  <span class="text-dark bold underline"> Ürün Tutarı </span>
                  <span class="text-primary bold">
                    {{ $toCurrency(priceToDiscount) }}
                  </span>
                </div>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="5"
                vs-offset="1"
                v-if="enteredPrice > 0"
              >
                <div
                  class="w-full half-friendly-border bg-secondary sale-box-shadow discount-old-title"
                >
                  <span class="text-dark bold underline">
                    Yeni Ürün Tutarı
                  </span>
                  <span class="text-success bold">
                    {{
                      (discountType == 0
                        ? priceToDiscount -
                          (priceToDiscount * enteredPrice) / 100
                        : priceToDiscount - enteredPrice
                      ).toFixed(2)
                    }}
                    ₺
                  </span>
                </div>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="center">
              <vs-col vs-type="flex" vs-w="5" vs-justify="flex-end">
                <vs-button
                  @click="
                    discountType = 0;
                    enteredPriceStr = '';
                  "
                  color="transparent"
                  class="friendly-border sale-box-shadow text-white bold bg-primary2"
                  :class="{
                    'bg-success': discountType == 0,
                    'pay-attention': discountType == null,
                  }"
                >
                  Yüzde(%)
                </vs-button>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="5"
                vs-offset="0.25"
                vs-justify="flex-start"
              >
                <vs-button
                  @click="
                    discountType = 1;
                    enteredPriceStr = '';
                  "
                  color="transparent"
                  class="friendly-border sale-box-shadow text-white bold bg-primary2"
                  :class="{
                    'bg-success': discountType == 1,
                    'pay-attention': discountType == null,
                  }"
                >
                  Tutar(₺)
                </vs-button>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="mt-4">
              <input style="display: none" type="text" name="username" />
              <v-select
                type="select"
                class="w-full"
                placeholder="İndirim Sebebi Giriniz."
                id="discountReason"
                v-model="selectedDiscountReason"
                disableBrowserAutocomplete
                :options="discountReasons"
                itemid="id"
                label="name"
                name="İndirim Sebebi"
                v-validate="'required|min:3'"
                push-tags
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('İndirim Sebebi')"
                >{{ errors.first("İndirim Sebebi") }}</span
              >
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-align="center" class="mt-4">
              <vs-textarea
                v-validate="isDiscountDescriptionRequired ? 'required' : ''"
                name="Açıklama"
                v-model="discountDescription"
                label="Açıklama"
                :class="{ 'mobile-textarea': isMobile }"
              />
            </vs-row>
          </vs-row>
          <vs-row
            v-if="!isMobile"
            vs-type="flex"
            vs-w="12"
            class="mt-auto"
            vs-justify="space-between"
          >
            <vs-col vs-type="flex" vs-w="5.75">
              <vs-button
                @click="getBack"
                size="large"
                icon="icon-arrow-left"
                icon-pack="feather"
                color="transparent"
                class="w-full half-friendly-border sale-box-shadow bg-secondary text-primary bold"
              >
                Vazgeç
              </vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-w="5.75">
              <vs-button
                size="large"
                color="transparent"
                @click="appendDiscount"
                :disabled="
                  discountType == null ||
                  enteredPrice == 0 ||
                  selectedDiscountReason == null ||
                  (isDiscountDescriptionRequired && (!discountDescription || discountDescription.trim() === ''))
                "
                class="w-full half-friendly-border sale-box-shadow bg-success text-white bold"
              >
                Uygula
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col
        vs-type="flex"
        class="flex-col"
        :vs-w="isMobile ? 12 : 5"
        :vs-offset="isMobile ? 0 : 0.5"
      >
        <vs-row vs-type="block" vs-w="12">
          <vs-row vs-type="flex" vs-w="12">
            <div class="w-full calc-screen half-friendly-border px-5 py-1">
              <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end">
                <p
                  class="bold calc-screen-entry-price"
                  :class="{ 'text-dark': discountType != null }"
                >
                  - {{ enteredPriceStr }} {{ discountType == 0 ? "%" : "₺" }}
                </p>
              </vs-row>
            </div>

            <vs-row v-if="!isMobile" vs-type="flex" vs-w="12">
              <vs-button
                color="transparent"
                :disabled="discountType == null"
                class="mt-2 w-full sale-box-shadow bg-secondary text-small border text-primary bold"
                @click="clearEnteredPrice"
              >
                Sil
              </vs-button>
            </vs-row>

            <!-- Preset rate buttons visible on all devices, forced onto a single row -->
            <div class="w-full mt-2" style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: space-between;">
              <div
                v-for="rate in rates"
                :key="rate.name"
                style="flex: 1; padding: 0 4px; display: flex;"
              >
                <span
                  @click="
                    discountType != null ? spliceTotalPrice(rate.value) : null
                  "
                  :class="{ disabled: discountType == null }"
                  class="w-full pointer bg-secondary bold half-friendly-border sale-box-shadow text-primary text-small text-center py-4 border"
                  style="white-space: nowrap; display: flex; align-items: center; justify-content: center;"
                >
                  {{ rate.name }}
                </span>
              </div>
            </div>

            <!-- Input field for mobile devices -->
            <vs-row v-if="isMobile" vs-type="flex" vs-w="12" class="mt-3">
              <vs-input
                class="w-full"
                :label="discountType == 0 ? 'İndirim Yüzdesi (%)' : 'İndirim Tutarı (₺)'"
                v-model="enteredPriceStr"
                type="number"
                step="0.01"
                :disabled="discountType == null"
              />
            </vs-row>

            <vs-row v-if="isMobile" vs-type="flex" vs-w="12">
              <vs-button
                color="transparent"
                :disabled="discountType == null"
                class="mt-2 w-full sale-box-shadow bg-secondary text-small border text-primary bold"
                @click="clearEnteredPrice"
              >
                Sil
              </vs-button>
            </vs-row>

            <!-- Numeric keypad only visible on desktop -->
            <vs-row v-if="!isMobile" vs-type="flex" vs-w="12" vs-justify="space-between">
              <vs-col
                vs-type="flex"
                vs-w="3.5"
                v-for="number in numbers"
                :key="number"
                class="mt-2"
              >
                <span
                  @click="discountType != null ? appendNumber(number) : null"
                  :class="{ disabled: discountType == null }"
                  class="w-full pointer bg-secondary bold half-friendly-border sale-box-shadow text-primary text-small text-center py-4 border"
                >
                  {{ number }}
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="7.75"
                class="mt-2 height-fit line-medium"
              >
                <span
                  @click="discountType != null ? enterZero() : null"
                  :class="{ disabled: discountType == null }"
                  class="w-full pointer bg-secondary bold half-friendly-border sale-box-shadow text-primary text-small text-center py-5 border"
                >
                  {{ 0 }}
                </span>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-w="3.5"
                class="mt-2 height-fit line-medium"
              >
                <span
                  @click="discountType != null ? enterComma() : null"
                  :class="{ disabled: discountType == null }"
                  class="w-full pointer bg-secondary bold half-friendly-border sale-box-shadow text-primary text-small text-center py-5 border"
                >
                  ,
                </span>
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-row>
        <vs-row
          v-if="isMobile"
          vs-type="flex"
          vs-w="12"
          class="mobile-action-buttons"
          vs-justify="space-between"
        >
          <vs-col vs-type="flex" vs-w="5.75">
            <vs-button
              @click="getBack"
              size="large"
              icon="icon-arrow-left"
              icon-pack="feather"
              color="transparent"
              class="w-full half-friendly-border sale-box-shadow bg-secondary text-primary bold"
            >
              Vazgeç
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-w="5.75">
            <vs-button
              size="large"
              color="transparent"
              @click="appendDiscount"
              :disabled="
                discountType == null ||
                enteredPrice == 0 ||
                selectedDiscountReason == null ||
                (isDiscountDescriptionRequired && (!discountDescription || discountDescription.trim() === ''))
              "
              class="w-full half-friendly-border sale-box-shadow bg-success text-white bold"
            >
              Uygula
            </vs-button>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import { GetAllDiscountReason } from "@/api/DiscountReason.js";
import { currentBranch } from "@/api/Branch.js";
export default {
  props: {
    priceToDiscount: {
      type: Number,
      required: true,
    },
    currentTime: {
      type: String,
      required: true,
    },
    currentDate: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedDiscountReason: null,
      discountDescription: "",
      isActive: false,
      discountType: 0,
      discountReasons: [],
      isMobile: null,
      numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      numberRates: [
        {
          id: 1,
          value: 100,
          name: "İkram",
        },
        {
          id: 2,
          value: 50,
          name: "1/2",
        },
        {
          id: 3,
          value: 33.3333,
          name: "1/3",
        },
        {
          id: 4,
          value: 25,
          name: "1/4",
        },
      ],
      percentRates: [
        {
          id: 1,
          value: 100,
          name: "İkram",
        },
        {
          id: 2,
          value: 25,
          name: "%25",
        },
        {
          id: 3,
          value: 20,
          name: "%20",
        },
        {
          id: 4,
          value: 15,
          name: "%15",
        },
        {
          id: 5,
          value: 10,
          name: "%10",
        },
      ],
      enteredPrice: 0,
      enteredPriceStr: "",
      localBranchSetting: null
    };
  },
  computed: {
    rates() {
      return this.discountType == 0 ? this.percentRates : this.numberRates;
    },
    activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    },
    isDiscountDescriptionRequired() {
      let setting = this.localBranchSetting;
      if (setting) {
        if (typeof setting === 'string') {
          try {
            setting = JSON.parse(setting);
          } catch (e) {}
        }
        const isRequired = setting.discountDescriptionRequired !== undefined 
          ? setting.discountDescriptionRequired 
          : setting.DiscountDescriptionRequired;
        if (isRequired === false || isRequired === 'false' || (isRequired && String(isRequired).toLowerCase() === 'false')) {
          return false;
        }
        return true;
      }

      // Fallback to activeUser
      const activeUser = this.$store.state.AppActiveUser || JSON.parse(localStorage.getItem("userInfo"));
      if (activeUser && activeUser.branch) {
        let userSetting = activeUser.branch.setting || activeUser.branch.Setting;
        if (userSetting) {
          if (typeof userSetting === 'string') {
            try {
              userSetting = JSON.parse(userSetting);
            } catch (e) {}
          }
          const isRequired = userSetting.discountDescriptionRequired !== undefined 
            ? userSetting.discountDescriptionRequired 
            : userSetting.DiscountDescriptionRequired;
          if (isRequired === false || isRequired === 'false' || (isRequired && String(isRequired).toLowerCase() === 'false')) {
            return false;
          }
          return true;
        }
      }
      return true; // Default behavior
    },
  },
  watch: {
    enteredPriceStr: function (newVal, oldVal) {
      if (newVal == "") {
        this.enteredPrice = 0;
        return;
      }

      // Handle number input on mobile which might use dot instead of comma
      let parsedVal = newVal;
      if (this.isMobile && typeof newVal === 'string') {
        // Convert dots to commas for consistency
        parsedVal = newVal.replace('.', ',');
      }

      let parsedPrice = parseFloat(parsedVal.replace(",", "."));
      if (this.discountType == 1) {
        if (parsedPrice > this.priceToDiscount) {
          if (this.isMobile) {
            // For mobile, just cap at the maximum
            this.enteredPrice = this.priceToDiscount;
            this.enteredPriceStr = this.priceToDiscount.toString().replace('.', ',');
          } else {
            this.enteredPriceStr = oldVal;
          }
        } else {
          this.enteredPrice = parsedPrice;
        }
      } else if (this.discountType == 0) {
        if (parsedPrice > 100) {
          if (this.isMobile) {
            // For mobile, just cap at 100
            this.enteredPrice = 100;
            this.enteredPriceStr = "100";
          } else {
            this.enteredPriceStr = oldVal;
          }
        } else {
          this.enteredPrice = parsedPrice;
        }
      }
    },
    isActive(val) {
      if (!val) {
        this.initValues();
      } else {
        this.fetchBranchSettings();
        this.getdiscountReasons();
      }
    },
  },
  methods: {
    checkScreen() {
      this.isMobile = window.innerWidth <= 768;
    },
    getdiscountReasons() {
      GetAllDiscountReason()
        .then((res) => {
          if (res && res.status == 200) {
            this.discountReasons = res.data;
            this.setDefaultDiscountReason();
          } else {
            this.$fire({
              title: "Hata : " + res.status,
              text: "İndirim Sebepleri Yüklenemedi !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "İndirim Sebepleri Yüklenemedi !",
            });
          }
        })
        .catch((error) => {
          this.$fire({
            title: "Hata",
            text: "Sunucu Bağlantı Hatası !",
            type: "error",
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    initValues() {
      this.selectedDiscountReason = null;
      this.discountDescription = "";
      this.discountType = 0;
      this.enteredPrice = 0;
      this.enteredPriceStr = "";
      this.localBranchSetting = null;
      this.$validator.reset();
      this.setSelectDefaultPaymentMethod();
    },
    async fetchBranchSettings() {
      try {
        const res = await currentBranch();
        if (res && res.data) {
          let setting = res.data.setting || res.data.Setting;
          if (setting) {
            if (typeof setting === 'string') {
              try {
                setting = JSON.parse(setting);
              } catch (e) {
                console.error("Error parsing setting string:", e);
              }
            }
            this.localBranchSetting = setting;
            this.setDefaultDiscountReason();
          }
        }
      } catch (err) {
        console.error("Error fetching branch settings in Discount.vue:", err);
      }
    },
    setDefaultDiscountReason() {
      if (!this.isDiscountDescriptionRequired && this.discountReasons && this.discountReasons.length > 0) {
        const reason = this.discountReasons.find(r => r && r.name && (
          r.name.toLowerCase() === 'diğer' || 
          r.name.toLowerCase() === 'diger' || 
          r.name.toLowerCase().includes('diğ') || 
          r.name.toLowerCase().includes('dig')
        ));
        if (reason) {
          this.selectedDiscountReason = reason;
        } else {
          this.selectedDiscountReason = this.discountReasons[0];
        }
      }
    },
    appendDiscount() {
      if (this.$validator.validateAll()) {
        let discountObj = {
          originPrice: this.priceToDiscount,
          priceToDiscount:
            this.discountType == 1
              ? this.enteredPrice
              : (this.priceToDiscount * this.enteredPrice) / 100,
          payedPrice:
            this.priceToDiscount -
            (this.discountType == 1
              ? this.enteredPrice
              : (this.priceToDiscount * this.enteredPrice) / 100),
          value: this.enteredPrice,
          description: this.selectedDiscountReason.name + (this.discountDescription ? " - " + this.discountDescription : ""),
          unit: this.discountType == 1 ? "₺" : "%",
          discountDescription: this.discountDescription,
        };
        //  this.$store.dispatch('selfservice/CART_PRICE_UPDATE', discountObj)
        this.$emit("appendDiscount", discountObj);
        this.isActive = false;
      }
    },
    setSelectDefaultPaymentMethod() {
      const methods = this.$store.getters["selfservice/getPaymentMethods"];
      const creditId = process.env.VUE_APP_CREDIT_PAYMENT_ID ? parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID) : 2;
      const creditCard = methods.find(m => m.id == creditId);
      this.$store.dispatch(
        "selfservice/setSelectedPaymentMethod",
        creditCard || methods[0]
      );
    },
    getBack() {
      this.isActive = false;
    },
    spliceTotalPrice(rate) {
      this.enteredPriceStr = "";
      if (this.discountType == 0) {
        // For percentage discount
        this.enterPriceData(rate.toString());
      } else if (this.discountType == 1) {
        // For amount discount
        let value = (this.priceToDiscount * rate) / 100;
        value = value.toFixed(2);

        if (this.isMobile) {
          // For mobile, format with dot for number input
          this.enteredPriceStr = value.toString();
        } else {
          // For desktop, use comma
          value = value.replace(".", ",");
          this.enterPriceData(value);
        }
      }
    },
    clearLastChar: function () {
      this.enteredPriceStr = this.enteredPriceStr.substring(
        0,
        this.enteredPriceStr.length - 1
      );
    },
    appendNumber: function (str) {
      this.enterPriceData(str);
    },
    clearEnteredPrice: function () {
      this.enteredPriceStr = "";
    },
    enterComma: function () {
      this.enterPriceData(",");
    },
    enterZero: function () {
      this.enterPriceData("0");
    },
    enterPriceData: function (val) {
      if (this.enteredPriceStr.includes(",")) {
        let split = this.enteredPriceStr.split(",");
        if (split[1].length > 1) {
          return;
        }
      }
      if (val === ",") {
        if (!this.enteredPriceStr.includes(",")) {
          if (this.enteredPriceStr.length === 0) {
            this.enteredPriceStr = this.enteredPriceStr + "0" + val;
          } else {
            this.enteredPriceStr = this.enteredPriceStr + val;
          }
        }
      } else if (val === "0") {
        if (this.enteredPriceStr.length > 0) {
          this.enteredPriceStr = this.enteredPriceStr + val;
        } else {
          return;
        }
      } else {
        this.enteredPriceStr = this.enteredPriceStr + val;
      }
    },
  },
  created() {
    this.checkScreen();
    window.addEventListener("resize", this.checkScreen);
  },
  mounted() {
    let ex = document.querySelectorAll('[role="combobox"]');
    ex[0].name = "discountReasonInput";
  },
  destroyed() {
    window.removeEventListener("resize", this.checkScreen);
  },
};
</script>

<style>
.payment-label i {
  font-size: 2rem !important;
  margin-right: 2rem !important;
}
.payment-label .vs-button-text {
  font-size: 1rem !important;
}
#discount .vs-popup .vs-popup--header {
  display: none;
}

#discount .vs-popup .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
  overflow: hidden !important;
}

#discount .vs-popup {
  border-radius: 2rem !important;
  width: 1000px !important;
  overflow: hidden;
}

@media (max-width: 768px) {
  #discount .vs-popup .vs-popup--content {
    max-height: calc(100vh) !important;
  }
  #discount .vs-popup {
    max-height: 100vh !important;
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    margin: 0 !important;
    top: 0 !important;
    left: 0 !important;
    border-radius: 0 !important;
    position: fixed !important;
  }

  .mobile-content {
    height: calc(100vh);
    width: 100%;
    padding-top: 10px !important;
  }

  .mobile-action-buttons {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    background: white;
    padding: 10px 15px;
    box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
    margin: 0 !important;
    width: 100%;
  }

  /* Improved spacing for mobile interface */
  .vs-row[vs-justify="space-between"] {
    margin-bottom: 15px !important;
  }

  /* More space for the preset buttons on mobile */
  .vs-col[vs-w="4"] span {
    font-size: 16px !important;
    padding: 12px 0 !important;
  }

  /* Better spacing for the input field */
  .vs-input {
    margin-bottom: 10px !important;
  }

  /* Make input text bigger on mobile */
  .vs-input input {
    font-size: 18px !important;
  }

  .vs-textarea-primary {
    margin-bottom: 70px !important;
  }

  /* Fix the excessive spacing under textarea */
  .mobile-textarea {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  .mobile-textarea .vs-textarea {
    margin-bottom: 0 !important;
  }

  /* Fix alignment of discount form on mobile */
  .vs-row.vs-align-center.mt-4 {
    margin-bottom: 0 !important;
  }

  /* Compact the form fields */
  .vs-col.w-full {
    margin-bottom: 5px !important;
  }

  /* Remove extra padding in content area on mobile */
  .mobile-content {
    padding-bottom: 65px !important;
  }

  /* Adjust spacing for v-select on mobile */
  .vs__dropdown-toggle {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  /* Specifically target the textarea and v-select containers */
  .vs-row.vs-type-flex.vs-w-12.mt-4 {
    margin-bottom: 5px !important;
  }

  .vs-select .vs__dropdown-menu {
    z-index: 100 !important;
  }

  .vs-textarea-primary textarea {
    margin-bottom: 0 !important;
    min-height: 60px !important; /* Smaller text area on mobile */
  }

  .info-row {
    padding: 0 15px;
  }
}

.discount-old-title {
  justify-content: center;
  text-align: center;
  display: grid;
  padding: 10px 0 10px 0;
}

.pay-attention {
  -webkit-animation: glowing 1500ms infinite;
  -moz-animation: glowing 1500ms infinite;
  -o-animation: glowing 1500ms infinite;
  animation: glowing 1500ms infinite;
}

@-webkit-keyframes glowing {
  0% {
    background-color: rgb(21, 178, 0);
    -webkit-box-shadow: 0 0 3px rgb(21, 178, 0);
  }

  50% {
    background-color: rgb(0, 255, 34);
    -webkit-box-shadow: 0 0 40px rgb(0, 255, 34);
  }

  100% {
    background-color: rgb(21, 178, 0);
    -webkit-box-shadow: 0 0 3px rgb(21, 178, 0);
  }
}

@-moz-keyframes glowing {
  0% {
    background-color: rgb(21, 178, 0);
    -moz-box-shadow: 0 0 3px rgb(21, 178, 0);
  }

  50% {
    background-color: rgb(0, 255, 34);
    -moz-box-shadow: 0 0 40px rgb(0, 255, 34);
  }

  100% {
    background-color: rgb(21, 178, 0);
    -moz-box-shadow: 0 0 3px rgb(21, 178, 0);
  }
}

@-o-keyframes glowing {
  0% {
    background-color: rgb(21, 178, 0);
    box-shadow: 0 0 3px rgb(21, 178, 0);
  }

  50% {
    background-color: rgb(0, 255, 34);
    box-shadow: 0 0 40px rgb(0, 255, 34);
  }

  100% {
    background-color: rgb(21, 178, 0);
    box-shadow: 0 0 3px rgb(21, 178, 0);
  }
}

@keyframes glowing {
  0% {
    background-color: rgb(21, 178, 0);
    box-shadow: 0 0 3px rgb(21, 178, 0);
  }

  50% {
    background-color: rgb(0, 255, 34);
    box-shadow: 0 0 40px rgb(0, 255, 34);
  }

  100% {
    background-color: rgb(21, 178, 0);
    box-shadow: 0 0 3px rgb(21, 178, 0);
  }
}

.vs__dropdown-menu {
  max-height: 19vh !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
}
</style>
